import React from "react"

import { ComponentWithChildren } from "@cirrus/core/decorators"
import { StylesProvider } from "@cirrus/ui-kit/src/components/styles-provider"

export const StylesDecorator: ComponentWithChildren = ({ children }) => (
  <StylesProvider>
    {children}
  </StylesProvider>
)
